import useSyncedAnimations from '../../../Hooks/useSyncedAnimations';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import logo from '../../../assets/static/TELogo.png';
import '../../../assets/styles/components/Loader.css';

const RINGS = ['orange', 'green', 'blue'];

const renderBrandSpans = (block) => RINGS.map((ring) => <span key={ring} className={`te-loader-${block} te-loader-${block}--${ring}`} />);

const Loader = () => {
  const { tempedgeTranslator } = useTempEdgeTranslator();
  const clockRef = useSyncedAnimations();

  return (
    <div ref={clockRef} className="te-loader" role="status" aria-live="polite" aria-busy="true">
      <div className="te-loader-orbit" aria-hidden="true">
        {renderBrandSpans('ring')}
        <span className="te-loader-core">
          <img className="te-loader-logo" src={logo} alt="" decoding="async" />
        </span>
      </div>
      <div className="te-loader-dots" aria-hidden="true">
        {renderBrandSpans('dot')}
      </div>
      <span className="sr-only">{tempedgeTranslator('com.tempedge.msg.label.loading')}</span>
    </div>
  );
};

export default Loader;
